import { get } from 'api/methods';

export interface ParametrosAssociadoResponse extends Record<string, any> {
  configTexto: boolean;
  texto: string | null;
  urlVideo: string;
}

const parametros = {
  listar: () => {
    return get<ParametrosAssociadoResponse>(
      'assembleiasAssociado',
      'parametro/'
    );
  },
};

export default parametros;
